<div class="qa-matrix-options">
  <div class="qa-matrix-x card">
    <div class="card-body">
      <div class="card-title">
        <h5>
          <img src="/assets/images/insert-row.svg" class="qa-insert-row">
          &nbsp;{{_(KEYS.EDITOR.ROWS)}}
        </h5>
      </div>

      <div class="qa-option-row" *ngFor="let element of rows; let position = index;">
    <span class="qa-option-number">{{position + 1}}</span>
    <div class="qa-option-order">
      <button type="button" (click)="onRowPositionChange(position, position - 1)" [disabled]="position === 0"
              [attr.aria-label]="_(KEYS.EDITOR.MOVE_UP)" [ngbTooltip]="_(KEYS.EDITOR.MOVE_UP)" container="body"><i class="fa fa-angle-up"></i></button>
      <button type="button" (click)="onRowPositionChange(position, position + 1)" [disabled]="position === rows.length - 1"
              [attr.aria-label]="_(KEYS.EDITOR.MOVE_DOWN)" [ngbTooltip]="_(KEYS.EDITOR.MOVE_DOWN)" container="body"><i class="fa fa-angle-down"></i></button>
    </div>
        <div class="qa-option-content">
          <label *ngIf="isScaleMode" class="qa-option-field-label">{{_(KEYS.EDITOR.LEFT_TEXT)}}</label>
          <div class="qa-option-text qa-fake-input" qaFroalaAutoScroll>
            <app-qa-lazy-froala [focusRequested]="previewFocusTarget === 'row-' + position"
              (focusHandled)="previewFocusHandled.emit()" [options]="answerEditorOptions" [(model)]="element.title[locale]" (blur)="updateElement()"></app-qa-lazy-froala>
          </div>
          <ng-container *ngIf="isScaleMode">
            <label class="qa-option-field-label">{{_(KEYS.EDITOR.RIGHT_TEXT)}}</label>
            <div class="qa-option-text qa-fake-input" qaFroalaAutoScroll>
              <app-qa-lazy-froala [focusRequested]="previewFocusTarget === 'appendix-' + position"
                (focusHandled)="previewFocusHandled.emit()" [options]="answerEditorOptions" [(model)]="element.appendix[locale]" (blur)="updateElement()"></app-qa-lazy-froala>
            </div>
          </ng-container>
          <div class="qa-option-meta" *ngIf="element.options?.mandatory"><span>{{_(KEYS.EDITOR.MANDATORY)}}</span></div>
        </div>
    <div ngbDropdown container="body" placement="bottom-right" class="qa-option-actions">
      <button type="button" class="qa-option-more" ngbDropdownToggle [attr.aria-label]="_(KEYS.EDITOR.OPTIONS) + ': ' + (position + 1)">
        <i class="fa fa-ellipsis-v"></i>
      </button>
      <div ngbDropdownMenu class="qa-option-menu">
          <button ngbDropdownItem (click)="onToggleRowMandatory(element)" [attr.aria-pressed]="!!element.options?.mandatory">
            <i class="fa" [ngClass]="element.options?.mandatory ? 'fa-check-square-o' : 'fa-square-o'"></i> {{_(KEYS.EDITOR.MANDATORY)}}
          </button>
          <button ngbDropdownItem (click)="onVariablesModal(element)"><i class="fa fa-code"></i> {{_(KEYS.EDITOR.VARIABLES)}}</button>
          <div class="dropdown-divider"></div>
          <button ngbDropdownItem class="text-danger" (click)="onDeleteRow(position)"><i class="fa fa-trash-o"></i> {{_(KEYS.EDITOR.REMOVE)}}</button>
        </div>
      </div>
      </div>

      <div class="btn-group mt-2">
        <button class="btn btn-sm btn-success" (click)="onAddRow()">
          <i class="fa fa-plus"></i> {{_(KEYS.EDITOR.ADD_ROW)}}
        </button>
      </div>
    </div>
  </div>

  <div class="qa-matrix-y card">
    <div class="card-body">
      <div class="card-title">
        <h5>
            <img src="/assets/images/insert-column.svg" class="qa-insert-column">
            &nbsp;{{_(KEYS.EDITOR.COLUMNS)}}
        </h5>
      </div>

      <div class="qa-option-row" *ngFor="let element of cols; let position = index;">
    <span class="qa-option-number">{{position + 1}}</span>
    <div class="qa-option-order">
      <button type="button" (click)="onColPositionChange(position, position - 1)" [disabled]="position === 0"
              [attr.aria-label]="_(KEYS.EDITOR.MOVE_UP)" [ngbTooltip]="_(KEYS.EDITOR.MOVE_UP)" container="body"><i class="fa fa-angle-up"></i></button>
      <button type="button" (click)="onColPositionChange(position, position + 1)" [disabled]="position === cols.length - 1"
              [attr.aria-label]="_(KEYS.EDITOR.MOVE_DOWN)" [ngbTooltip]="_(KEYS.EDITOR.MOVE_DOWN)" container="body"><i class="fa fa-angle-down"></i></button>
    </div>
        <div class="qa-option-content">
          <div class="qa-option-text qa-fake-input" qaFroalaAutoScroll>
            <app-qa-lazy-froala [focusRequested]="previewFocusTarget === 'column-' + position"
              (focusHandled)="previewFocusHandled.emit()" [options]="answerEditorOptions" [(model)]="element.title[locale]" (blur)="updateElement()"></app-qa-lazy-froala>
          </div>
        </div>
        <button type="button" class="qa-option-more qa-option-delete" (click)="onDeleteColumn(position)" [attr.aria-label]="_(KEYS.EDITOR.REMOVE) + ': ' + (position + 1)">
          <i class="fa fa-trash-o"></i>
        </button>
      </div>

      <div class="btn-group mt-2">
        <button class="btn btn-sm btn-success" (click)="onAddColumn()">
          <i class="fa fa-plus"></i> {{_(KEYS.EDITOR.ADD_COLUMN)}}
        </button>
      </div>
    </div>
  </div>

  <div class="qa-matrix-display-type input-group">
    <span class="input-group-addon">{{_(KEYS.EDITOR.ANSWERS_PER_ROW)}}</span>
    <select class="form-control qa-custom-select" [(ngModel)]="question.displayType">
      <option value="radio">{{_(KEYS.EDITOR.SINGLE_CHOICE)}}</option>
      <option value="checkbox">{{_(KEYS.EDITOR.MULTIPLE_CHOICE)}}</option>
    </select>
  </div>

  <section class="qa-matrix-cells" *ngIf="cols.length && rows.length">
    <div class="qa-cell-heading">
      <h5><i class="fa fa-th" aria-hidden="true"></i> {{_(KEYS.EDITOR.CONFIGURE_CELLS)}}</h5>
      <p>{{_(KEYS.EDITOR.SELECT_MATRIX_CELL)}}</p>
    </div>
    <div class="qa-cell-scroll" (mouseleave)="hoveredRow = -1; hoveredColumn = -1">
      <table class="qa-cell-grid" [attr.aria-label]="_(KEYS.EDITOR.CONFIGURE_CELLS)">
        <thead>
          <tr>
            <th class="qa-cell-corner" scope="col">{{_(KEYS.EDITOR.ROW)}} / {{_(KEYS.EDITOR.COLUMN)}}</th>
            <th *ngFor="let col of cols; let c = index; trackBy: trackMatrixElement" scope="col"
                [class.axis-active]="hoveredColumn === c || selectedColumnId === col.id">
              {{(col.title[locale] | striptags | htmldecode) || (_(KEYS.EDITOR.COLUMN) + ' ' + (c + 1))}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows; let r = index; trackBy: trackMatrixElement">
            <th scope="row" [class.axis-active]="hoveredRow === r || selectedRowId === row.id">
              {{(row.title[locale] | striptags | htmldecode) || (_(KEYS.EDITOR.ROW) + ' ' + (r + 1))}}
              <span class="qa-cell-appendix" *ngIf="row.appendix && row.appendix[locale]">
                {{row.appendix[locale] | striptags | htmldecode}}
              </span>
            </th>
            <td *ngFor="let cell of row.elements; let c = index; trackBy: trackMatrixElement">
              <button #cellButton type="button" class="qa-cell-button" *ngIf="getCellVariables(cell) as variables"
                      [attr.data-cell-focus]="'cell-' + r + '-' + c"
                      [class.cell-selected]="selectedRowId === row.id && selectedColumnId === cell.id"
                      [attr.aria-pressed]="selectedRowId === row.id && selectedColumnId === cell.id"
                      [attr.aria-label]="_(KEYS.EDITOR.CONFIGURE_CELLS) + ': ' +
                        ((row.title[locale] | striptags | htmldecode) || (_(KEYS.EDITOR.ROW) + ' ' + (r + 1))) + ', ' +
                        ((cell.title[locale] | striptags | htmldecode) || (_(KEYS.EDITOR.COLUMN) + ' ' + (c + 1)))"
                      (mouseenter)="hoveredRow = r; hoveredColumn = c"
                      (focus)="hoveredRow = r; hoveredColumn = c" (blur)="hoveredRow = -1; hoveredColumn = -1"
                      (click)="selectCell(row, cell)">
                <span class="qa-cell-score" *ngIf="getScoringInfo(cell) as score; else noScore">
                  <i class="fa fa-sort-numeric-asc" aria-hidden="true"></i> {{score.variableName}}: <strong>{{score.value}}</strong>
                </span>
                <ng-template #noScore><i *ngIf="!variables.length" class="fa fa-plus qa-cell-add" aria-hidden="true"></i></ng-template>
                <span class="qa-cell-variable" *ngFor="let variable of variables; trackBy: trackCellVariable">
                  <span>{{variable.label}}</span><strong>{{variable.name}}</strong>
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <section #cellDetail class="qa-cell-detail" *ngFor="let cell of selectedCells">
      <div class="qa-cell-context">
        <span><small>{{_(KEYS.EDITOR.ROW)}}</small><strong>
          {{(selectedRow.title[locale] | striptags | htmldecode) || (_(KEYS.EDITOR.ROW) + ' ' + (rows.indexOf(selectedRow) + 1))}}
        </strong></span>
        <i class="fa fa-angle-right" aria-hidden="true"></i>
        <span><small>{{_(KEYS.EDITOR.COLUMN)}}</small><strong>
          {{(selectedColumn.title[locale] | striptags | htmldecode) || (_(KEYS.EDITOR.COLUMN) + ' ' + (cols.indexOf(selectedColumn) + 1))}}
        </strong></span>
      </div>
      <app-qa-matrix-cell-settings [container]="cell"></app-qa-matrix-cell-settings>
    </section>
  </section>
</div>
